"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterOnElement = void 0;
/**
 * Car part displayed at the center of a damage area.
 *
 * *Swagger Schema Reference :* `CenterOnElement`
 */
var CenterOnElement;
(function (CenterOnElement) {
    CenterOnElement["FRONT"] = "front";
    CenterOnElement["BACK"] = "back";
    CenterOnElement["LEFT"] = "left";
    CenterOnElement["RIGHT"] = "right";
    CenterOnElement["FRONT_LEFT"] = "front_left";
    CenterOnElement["FRONT_RIGHT"] = "front_right";
    CenterOnElement["BACK_LEFT"] = "back_left";
    CenterOnElement["BACK_RIGHT"] = "back_right";
    CenterOnElement["KEYS"] = "keys";
    CenterOnElement["DASHBOARD"] = "dashboard";
    CenterOnElement["UNDERCARRIAGE"] = "undercarriage";
    CenterOnElement["SEATS"] = "seats";
    CenterOnElement["TRUNK_INTERIOR"] = "trunk_interior";
    CenterOnElement["IGNORE"] = "ignore";
    CenterOnElement["BACKGROUND"] = "background";
    CenterOnElement["BUMPER_BACK"] = "bumper_back";
    CenterOnElement["BUMPER_FRONT"] = "bumper_front";
    CenterOnElement["DOOR_BACK_LEFT"] = "door_back_left";
    CenterOnElement["DOOR_BACK_RIGHT"] = "door_back_right";
    CenterOnElement["DOOR_FRONT_LEFT"] = "door_front_left";
    CenterOnElement["DOOR_FRONT_RIGHT"] = "door_front_right";
    CenterOnElement["FENDER_BACK_LEFT"] = "fender_back_left";
    CenterOnElement["FENDER_BACK_RIGHT"] = "fender_back_right";
    CenterOnElement["FENDER_FRONT_LEFT"] = "fender_front_left";
    CenterOnElement["FENDER_FRONT_RIGHT"] = "fender_front_right";
    CenterOnElement["FOG_LIGHT_BACK_LEFT"] = "fog_light_back_left";
    CenterOnElement["FOG_LIGHT_BACK_RIGHT"] = "fog_light_back_right";
    CenterOnElement["FOG_LIGHT_FRONT_LEFT"] = "fog_light_front_left";
    CenterOnElement["FOG_LIGHT_FRONT_RIGHT"] = "fog_light_front_right";
    CenterOnElement["GRILL"] = "grill";
    CenterOnElement["GRILL_LOW"] = "grill_low";
    CenterOnElement["GRILL_RADIATOR"] = "grill_radiator";
    CenterOnElement["HANDLE_BACK_LEFT"] = "handle_back_left";
    CenterOnElement["HANDLE_BACK_RIGHT"] = "handle_back_right";
    CenterOnElement["HANDLE_FRONT_LEFT"] = "handle_front_left";
    CenterOnElement["HANDLE_FRONT_RIGHT"] = "handle_front_right";
    CenterOnElement["HEAD_LIGHT_LEFT"] = "head_light_left";
    CenterOnElement["HEAD_LIGHT_RIGHT"] = "head_light_right";
    CenterOnElement["HEADER_PANEL"] = "header_panel";
    CenterOnElement["HOOD"] = "hood";
    CenterOnElement["HOOK"] = "hook";
    CenterOnElement["HUBCAP"] = "hubcap";
    CenterOnElement["HUBCAP_BACK_LEFT"] = "hubcap_back_left";
    CenterOnElement["HUBCAP_BACK_RIGHT"] = "hubcap_back_right";
    CenterOnElement["HUBCAP_FRONT_LEFT"] = "hubcap_front_left";
    CenterOnElement["HUBCAP_FRONT_RIGHT"] = "hubcap_front_right";
    CenterOnElement["INDICATOR_LIGHT_LEFT"] = "indicator_light_left";
    CenterOnElement["INDICATOR_LIGHT_RIGHT"] = "indicator_light_right";
    CenterOnElement["LICENSE_PLATE_BACK"] = "license_plate_back";
    CenterOnElement["LICENSE_PLATE_FRONT"] = "license_plate_front";
    CenterOnElement["LOGO"] = "logo";
    CenterOnElement["MIRROR_SUPPORT"] = "mirror_support";
    CenterOnElement["MIRROR_LEFT"] = "mirror_left";
    CenterOnElement["MIRROR_RIGHT"] = "mirror_right";
    CenterOnElement["PETROL_DOOR"] = "petrol_door";
    CenterOnElement["PILLAR"] = "pillar";
    CenterOnElement["QUARTER_WINDOW_BACK_LEFT"] = "quarter_window_back_left";
    CenterOnElement["QUARTER_WINDOW_BACK_RIGHT"] = "quarter_window_back_right";
    CenterOnElement["QUARTER_WINDOW_FRONT_LEFT"] = "quarter_window_front_left";
    CenterOnElement["QUARTER_WINDOW_FRONT_RIGHT"] = "quarter_window_front_right";
    CenterOnElement["REAR_SPOILER"] = "rear_spoiler";
    CenterOnElement["ROCKER_PANEL"] = "rocker_panel";
    CenterOnElement["ROCKER_PANEL_LEFT"] = "rocker_panel_left";
    CenterOnElement["ROCKER_PANEL_RIGHT"] = "rocker_panel_right";
    CenterOnElement["ROOF"] = "roof";
    CenterOnElement["TAIL_LIGHT_CENTER"] = "tail_light_center";
    CenterOnElement["TAIL_LIGHT_LEFT"] = "tail_light_left";
    CenterOnElement["TAIL_LIGHT_RIGHT"] = "tail_light_right";
    CenterOnElement["TRUNK"] = "trunk";
    CenterOnElement["TURN_SIGNAL_FRONT_LATERAL_LEFT"] = "turn_signal_front_lateral_left";
    CenterOnElement["TURN_SIGNAL_FRONT_LATERAL_RIGHT"] = "turn_signal_front_lateral_right";
    CenterOnElement["WHEEL_BACK_LEFT"] = "wheel_back_left";
    CenterOnElement["WHEEL_BACK_RIGHT"] = "wheel_back_right";
    CenterOnElement["WHEEL_FRONT_LEFT"] = "wheel_front_left";
    CenterOnElement["WHEEL_FRONT_RIGHT"] = "wheel_front_right";
    CenterOnElement["WINDOW_BACK_LEFT"] = "window_back_left";
    CenterOnElement["WINDOW_BACK_RIGHT"] = "window_back_right";
    CenterOnElement["WINDOW_CORNER_LEFT"] = "window_corner_left";
    CenterOnElement["WINDOW_CORNER_RIGHT"] = "window_corner_right";
    CenterOnElement["WINDOW_FRONT_LEFT"] = "window_front_left";
    CenterOnElement["WINDOW_FRONT_RIGHT"] = "window_front_right";
    CenterOnElement["WINDSHIELD_BACK"] = "windshield_back";
    CenterOnElement["WINDSHIELD_FRONT"] = "windshield_front";
    CenterOnElement["WIPER"] = "wiper";
    CenterOnElement["WIPER_BACK"] = "wiper_back";
    CenterOnElement["WIPER_FRONT"] = "wiper_front";
    CenterOnElement["WHEEL"] = "wheel";
})(CenterOnElement = exports.CenterOnElement || (exports.CenterOnElement = {}));
//# sourceMappingURL=entityTypes.js.map